import styled from 'styled-components';

import {breakpoint, colors} from 'theme';

import {Typography} from '../../pages/ProductsDetail/styled';
import {IconButton} from '../IconButton';
import {Tag} from '../Tags';

export const TitleWrapper = styled.div`
    margin-bottom: 24px;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
`;

export const TitleText = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
`;

export const Title = styled(Typography)`
    text-transform: uppercase;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.2;
    word-break: break-all;

    @media (min-width: ${breakpoint.phone}) {
        font-size: 18px;
    }
`;

export const Id = styled.span`
    color: ${colors.brandPrimary};
    text-transform: none;
`;

export const StatusWrapper = styled(Tag)`
    padding: 7px 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
`;

export const CopyButton = styled(IconButton)`
    margin-left: 5px;
    padding: 10px;
`;
